module.exports = "<p [className]=\"messagesData.type\">\n  {{ messagesData.message }}\n</p>\n"